import {
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { Router } from "@angular/router";
// ✅ CHANGED: IServerSideGetRowsParams → IDatasource, IGetRowsParams (infinite row model, not server-side)
import { ColDef, IDatasource, IGetRowsParams } from "ag-grid-community";
import { PermissionService } from "src/app/auth/permission.service";
import { ButtonRendererComponent } from "src/app/renderer/button-renderer.component";
import { AssetService } from "src/app/_services/asset.service";
import { UtilServiceService } from "src/app/_services/utilService/util-service.service";

import moment from "moment-timezone";
import {
  PERSISTANT_ITEM,
  ServerRequest,
} from "src/app/_models/global.data.model";
import { DeleteRecordService } from "src/app/_services/delete-record.service";
import { AuthenticationService } from "src/app/auth/authentication.service";
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { TableHeaderToolTipComponent } from "src/app/shared/table-header-tool-tip/table-header-tool-tip.component";
import { JobOrdersService } from "src/app/_services/job-orders.service";
import { ServiceZoneService } from "src/app/_services/service-zone.service";
import { DynamicFormService } from "src/app/_services/dynamic-form.service";
import { Global } from "src/app/_utilities/global";
import { DynamicTableColumnsService } from "src/app/_services/dynamic-table-column.service";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { NgxSpinnerService } from "ngx-spinner";

var dateFormateChange: any;

@Component({
  selector: "app-scheduled-maintenance-table",
  templateUrl: "./scheduled-maintenance-table.component.html",
  styleUrls: ["./scheduled-maintenance-table.component.scss"],
  standalone: false,
})
export class ScheduledMaintenanceTableComponent
  extends SubscriptionUtil
  implements OnInit, OnChanges, OnDestroy
{
  @Output() noDataEvent = new EventEmitter();
  @Input() id: any;
  @Input() forWhichModule: any;
  @Output() isFilterClosed = new EventEmitter();

  public isFilterToggleOn = false;
  public totalRecord: any;

  // grid
  gridApi: any;
  columnDefs: any[] = [];
  @Input() searchValue: any;
  pageSize: any = 25;
  // ✅ CHANGED: typed as any (GridOptions import removed), paginationPageSize removed (not used in infinite model)
  gridOptions!: any;
  frameworkComponents!: { buttonRenderer: any };
  defaultColDef: any;
  overlayNoRowsTemplate: any;
  gridParams: any;
  startFrom: any;
  parameters: any;
  scheduledMaintenance: any;
  noMaintenance: boolean = false;
  filter: any = {
    statuses: null,
    types: "",
    fromDate: "",
    toDate: "",
    serviceZoneId: null,
    JOtypes: null,
  };
  dateRange: any;
  selectedRange: any;
  serviceZones: any;
  create: any;

  public allTypes: any;
  allJobOrderTypes: any;
  public allStatus: any;
  public addonFeatureDYNAMIC: any;

  private filterAPILoaded = false;
  loadTable = 0;
  sortBy: any;
  sortOrder: any;
  dateFormat: any;
  actionData: any;
  @Input() translate: any;
  tableContent: any;
  preventiveMaintenanceIntroPageData: any;
  noSearchData: boolean = false;
  tenantPackages: any;
  // temp added for ENABLE_OLD_PM_VIEW add-on feature
  addonFeature: any;

  private readonly headerIdMap: any = {
  'scheduleNumber':           'Tbl_HeadPmNo',
};
displayNewPM3:boolean = false

  constructor(
    private assetService: AssetService,
    public util: UtilServiceService,
    private router: Router,
    private perm: PermissionService,
    private deleteRecordService: DeleteRecordService,
    private auth: AuthenticationService,
    private jobOrderService: JobOrdersService,
    private serviceZoneService: ServiceZoneService,
    private dynamicFormService: DynamicFormService,
    private dynamicTableColumnsService: DynamicTableColumnsService,
    private languageTranslateService: LanguageTranslateService,
    private spinner: NgxSpinnerService,
    private ngZone: NgZone,
  ) {
    super();
    this.preInit();
  }

  ngOnInit() { 
    this.addonFeature = this.auth.getAddonFeatureLists();
     /***********Check if the PMV3 package is old or new ***********/
    var tenantPackagesPM3 = this.auth.getPackageCodeWithList("PM3"); // Get the tenant's package information
    if (localStorage.getItem("packageCode") == "Old") {
      // Check if the package is old
      this.displayNewPM3 = this.addonFeature.addonPM3 == "PM3" ? true : false; // Show PMV3 menu if the addon feature is available
    } else {
      if (this.auth.getAddonPackageListsToHide("PM3")) {
        // we are hiding asset contract menu from profile if PROJECT is added in hidden package list
        this.displayNewPM3 =
          tenantPackagesPM3.addonPackageList == "PM3" ||
          this.addonFeature.addonPM3 == "PM3"
            ? true
            : false; // Show PMV3 menu if the addon package list includes PMV3
      } else {
        this.displayNewPM3 = false;
      }
    }
    this.init(); }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes &&
      changes['searchValue'] &&
      changes['searchValue'].previousValue !== changes['searchValue'].currentValue
    ) {
      this.onGridReady(this.gridParams);
    }

    if (
      changes &&
      changes['searchValue'] &&
      changes['searchValue'].previousValue !== changes['searchValue'].currentValue &&
      changes['searchValue'].currentValue === ""
    ) {
      this.onGridReady(this.gridParams);
    }

    if (
      changes &&
      changes['translate'] &&
      changes['translate'].previousValue != undefined &&
      Object.keys(changes['translate'].previousValue).length !== 0 &&
      changes['translate'].previousValue !== changes['translate'].currentValue
    ) {
      this.setOnlyColumn();
    }
  }

   // ✅ ADDED: called from (firstDataRendered) in template — sets accessibility header IDs
  public onFirstDataRendered(params: any) {
    Global.setHeaderIds(params, this.headerIdMap);
  }

  /******************************************** Set Only Column ******************************************/
  private setOnlyColumn() {
    this.gridOptions.columnDefs = [];
    const columnDefs: ColDef[] = [];
    this.tableContent.tableColumnSetups.forEach((element: any) => {
      this.cellRenderer(element);
      columnDefs.push(element);
    });
    this.actionData.headerName = this.translate?.general.buttons.action.singular;
    columnDefs.push(this.actionData);
    if (this.gridApi) {
      // ✅ CHANGED: setColumnDefs() → setGridOption("columnDefs", ...)
      this.gridApi.setGridOption("columnDefs", columnDefs);
      setTimeout(() => { this.gridApi.sizeColumnsToFit(); }, 500);
    }
  }

  ngOnDestroy(): void { this.onDestroy(); }

  /******************************************** Pre Init ******************************************/
  private preInit() {
    this.tenantPackages = this.auth.getPackageCodeWithList('PM');
    this.addonFeatureDYNAMIC = this.auth.getAddonFeatureLists().addonDYNAMICMAINTENANCE;
    // temp added for ENABLE_OLD_PM_VIEW add-on feature
    this.addonFeature = this.auth.getAddonFeatureLists();

    this.frameworkComponents = { buttonRenderer: ButtonRendererComponent };

    this.defaultColDef = {
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      sortable: true,
      resizable: true,
      filter: false,
      tooltipComponent: TableHeaderToolTipComponent,
    };

    this.gridOptions = {
      cacheBlockSize: 25,
      rowModelType: "infinite",
      sortingOrder: ["desc", "asc"],
      onGridSizeChanged: (params: any) => { params.api.sizeColumnsToFit(); },
      tooltipShowDelay: 100,
      // ✅ ADDED: required for AG Grid v35 — keeps legacy visual theme
      theme: "legacy",
      // ✅ KEPT: required for 'buttonRenderer' string key to resolve in AG Grid v35
      components: { buttonRenderer: ButtonRendererComponent },
    };

    this.actionData = {
      headerName: this.translate?.general.buttons.action.singular,
      filter: false,
      headerTooltip: "#",
      width: 150,
      sortable: false,
      headerClass: "marging-auto hide-action-border",
      cellStyle: { "text-align": "center" },
      cellRenderer: "buttonRenderer",
      cellRendererParams: {
        onClick: this.edit.bind(this),
        permissions: {
          update: this.perm.capable("scheduled_maintenance", "update"),
          remove: this.perm.capable("scheduled_maintenance", "remove"),
        },
        hidden: {
          update: !this.perm.capable("scheduled_maintenance", "update"),
          remove: !this.perm.capable("scheduled_maintenance", "remove"),
        },
      },
    };
  }

  /******************************************** Init ******************************************/
  private init() {
    this.create = this.perm.capable("scheduled_maintenance", "create");
    this.initializeColumns();
    this.allStatus = [
      { value: "PENDING",   label: this.translate?.general.status.pending.singular   },
      { value: "COMPLETED", label: this.translate?.general.status.completed.singular },
      { value: "OVER_DUE",  label: this.translate?.general.status.overdue.singular   },
      { value: "CANCELLED", label: this.translate?.general.status.cancelled.singular },
    ];
    this.allTypes = [
      { value: "BREAKDOWN",  label: this.translate?.general.status.breakDown.singular   },
      { value: "PREVENTIVE", label: this.translate?.general.status.preventive.singular  },
      { value: "ON_DEMAND",  label: this.translate?.general.status.onDemand.singular    },
      { value: "OTHERS",     label: this.translate?.maintenance.fields.other.singular   },
    ];
  }

  /******************************************** Initialize Columns ******************************************/
  private initializeColumns() {
    this.dateFormat = localStorage.getItem("date_format");
    dateFormateChange = this.auth.getUserTimezone();

    this.dynamicFormService.getTableColumn("maintenance_item").subscribe((res: any) => {
      this.tableContent = res;
      this.sortBy = res.sortBy;
      this.sortOrder = res.sortOrder;

      const columnDefs: any[] = [];
      res.tableColumnSetups.forEach((element: any) => {
        this.cellRenderer(element);
        columnDefs.push(element);
      });

      this.overlayNoRowsTemplate =
        "<div class='not-found'><span>" + this.translate?.general.messages.noRecordsFound + "</span> </div>";
      this.actionData.headerName = this.translate?.general.buttons.action.singular;
      columnDefs.push(this.actionData);

      this.loadTable = 1;

      if (this.gridApi) {
        // ✅ CHANGED: setColumnDefs() → setGridOption("columnDefs", ...)
        this.gridApi.setGridOption("columnDefs", columnDefs);
      } else {
        // grid not ready yet — set on gridOptions so it picks up on (gridReady)
        this.gridOptions.columnDefs = columnDefs;
      }

      this.onGridReady(this.gridParams);
    });
  }

  /******************************************** Cell Renderer ******************************************/
  private cellRenderer(element: any) {
    const dateFormat: any = localStorage.getItem("date_format");

    if (element.translatePath) {
      element.headerName = this.languageTranslateService.getNestedValue(this.translate, element.translatePath);
    }
    element.headerTooltip = "#";

    if (element.field === "scheduleNumber") {
    //  element.headerComponentParams = Global.setHeaderComponentParams(element, 'Tbl_HeadPmNo');
      element.cellRenderer = function (params: any) {
        if (params.data) {
          return Global.setCellRenderer(params, params.data.rowId, params.data.scheduleNumber);
        }
      };
    } else if (element.field === "type") {
      element.cellRenderer = (params: any) => {
        if (params.data) {
          if (params.data.type == "BREAKDOWN")  return "Break Down";
          if (params.data.type == "PREVENTIVE") return "Preventive";
          if (params.data.type == "ON_DEMAND")  return "On Demand";
          if (params.data.type == "OTHERS")     return "Others";
        }
      };
    } else if (element.field === "serviceType") {
      element.cellRenderer = (params: any) => {
        if (params.data) {
          if (params.data.serviceType == "MINOR") return "Minor";
          if (params.data.serviceType == "MAJOR") return "Major";
          return params.data.serviceType;
        }
      };
    } else if (element.field === "status") {
      element.cellRenderer = (params: any) => {
        if (params.data) {
          if (params.data.status == "PENDING") {
            return '<span class="p-tag p-component pending"><span class="p-tag-value text-dark">' + this.translate.general.status.pending.singular + "</span></span>";
          } else if (params.data.status == "COMPLETED") {
            return '<span class="p-tag p-component complete"><span class="p-tag-value text-dark">' + this.translate.general.status.completed.singular + "</span></span>";
          } else if (params.data.status == "OVER_DUE") {
            return '<span class="p-tag p-component overdue"><span class="p-tag-value text-dark">' + this.translate.general.status.overdue.singular + "</span></span>";
          } else if (params.data.status == "CANCELLED") {
            return '<span class="p-tag p-component cancel"><span class="p-tag-value text-dark">' + this.translate.general.status.cancelled.singular + "</span></span>";
          }
        }
      };
    } else if (
      element.dataType == 'date' ||
      element.dataType == "text" ||
      element.dataType == "time" ||
      element.dataType == "boolean"
    ) {
      element = Global.setColumnByDataType(element, this.auth.getUserTimezone(), dateFormat);
    }
  }

  /******************************************** On Destroy ******************************************/
  private onDestroy() { super.ngOnDestroy(); }

  /******************************************** On Grid Ready ******************************************/
  public onGridReady(params: any) {
    if (params) {
      this.gridParams = params;
      this.gridApi = params.api;
    }

    this.searchValue = this.searchValue ? this.searchValue : "";
    var count: number = 0;

    // ✅ IDatasource + IGetRowsParams (infinite row model)
    const dataSource: IDatasource = {
      getRows: (params: IGetRowsParams) => {
        if (this.loadTable == 1 && this.translate) {
          this.startFrom = params.startRow + 1;
          const serverParams = this.getRequestParams(params);
          const isDynamic =
            this.addonFeatureDYNAMIC || this.tenantPackages?.addonPackageList == 'PM' ? true : false;

          // All records — no filter by id or module
          if (!this.id && !this.forWhichModule) {
            this.assetService
              .getScheduledMaintenanceGridAll(
                this.startFrom, 25, this.searchValue,
                this.filter.statuses, this.filter.types, this.filter.JOtypes,
                this.filter.fromDate, this.filter.toDate, this.filter.serviceZoneId,
                serverParams.sortModel[0].colId, serverParams.sortModel[0].sort, isDynamic
              )
              .subscribe((data: any) => {
                this.scheduledMaintenance = data.data;
                this.scheduledMaintenance.forEach((element: any) => {
                  count++;
                  element.rowId = 'Tbl_RecPmNo' + count;
                  element.buttonEdit = 'Btn_PmEdit' + count;
                  element.buttonDelete = 'Btn_PmDel' + count;
                  // temp added for ENABLE_OLD_PM_VIEW add-on feature
                  if (this.addonFeature.addonENABLEOLDPMVIEW == 'ENABLE_OLD_PM_VIEW') {
                    element.hideOneActionButton = 'hideBothButton';
                  }
                });
                this.setGridData(params, this.scheduledMaintenance, data.total, data.status);
              });
          }

          // Maintenance scheduled maintenance module
          if (this.id && this.forWhichModule === "MaintenanceScheduledMaintenance") {
            this.push(
              this.assetService
                .getScheduledMaintenanceGrid(
                  this.startFrom, 25, this.searchValue, this.id,
                  this.filter.statuses, this.filter.types, this.filter.JOtypes,
                  this.filter.fromDate, this.filter.toDate, this.filter.serviceZoneId,
                  serverParams.sortModel[0].colId, serverParams.sortModel[0].sort
                )
                .subscribe((data: any) => {
                  this.scheduledMaintenance = data.data;
                  this.scheduledMaintenance.forEach((element: any) => {
                    count++;
                    element.rowId = 'Tbl_RecPmNo' + count;
                    element.buttonEdit = 'Btn_PmEdit' + count;
                    element.buttonDelete = 'Btn_PmDel' + count;
                  });
                  this.setGridData(params, this.scheduledMaintenance, data.total, data.status);
                })
            );
          }

          // Asset scheduled maintenance module
          if (this.id && this.forWhichModule === "AssetScheduledMaitenance") {
            this.push(
              this.assetService
                .getScheduledMaintenanceGridAssets(
                  this.startFrom, 25, this.searchValue, this.id,
                  this.filter.statuses, this.filter.types, this.filter.JOtypes,
                  this.filter.fromDate, this.filter.toDate, this.filter.serviceZoneId,
                  serverParams.sortModel[0].colId, serverParams.sortModel[0].sort
                )
                .subscribe((data: any) => {
                  this.scheduledMaintenance = data.data;
                  this.scheduledMaintenance.forEach((element: any) => {
                    count++;
                    element.rowId = 'Tbl_RecPmNo' + count;
                    element.buttonEdit = 'Btn_PmEdit' + count;
                    element.buttonDelete = 'Btn_PmDel' + count;
                  });
                  this.setGridData(params, this.scheduledMaintenance, data.total, data.status);
                })
            );
          }
        }
      },
    };

    if (this.gridApi) {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.setGridOption("datasource", dataSource);
    }
  }

  /******************************************** Get Request Params ******************************************/
  private getRequestParams(agGridRequest: any): ServerRequest {
    if (agGridRequest.sortModel.length <= 0) {
      this.parameters = { colId: this.sortBy, sort: this.sortOrder };
      agGridRequest.sortModel.push(this.parameters);
    }
    return {
      startRow: agGridRequest.startRow,
      pageSize: 25,
      filterModel: null,
      sortModel: agGridRequest.sortModel,
    };
  }

  /******************************************** Set Grid Data ******************************************/
  // ✅ IGetRowsParams + successCallback()
  private setGridData(
    agGridGetRowsParams: IGetRowsParams,
    resultItems: any[],
    totalCount: number,
    status: string
  ) {
    this.gridApi.hideOverlay();

    this.totalRecord = totalCount;
    this.scheduledMaintenance = resultItems;

    if (status === "NO_DATA" || status === "SEARCH_NO_RESULTS") {
      this.loadEmptyPage();
      this.noMaintenance = true;
    } else {
      this.noMaintenance = false;
    }

    if (this.scheduledMaintenance.length === 0) {
      this.gridApi.showNoRowsOverlay();
    } else {
      // ✅ successCallback replaces .success({rowData, rowCount})
      agGridGetRowsParams.successCallback(this.scheduledMaintenance, totalCount);
    }

    this.noSearchData = status === "NO_DATA" || status === "SEARCH_NO_RESULTS";
    this.noDataEvent.emit({ noData: this.noMaintenance, status: status });
    this.gridApi.sizeColumnsToFit();
  }

  /******************************************** Refresh ******************************************/
  public refresh() { this.onGridReady(this.gridParams); }

  /******************************************** Edit / Delete ******************************************/
  private edit(e: any) {
    if (e.action === "edit") {
      this.util.setPersistantItem(PERSISTANT_ITEM.SCHEDULE_MAINTENANCE, e.rowData);
      this.router.navigate(["/dashboard/preventative-maintenance/update"]);
    } else if (e.action === "delete") {
      const item = {
        deleteHeader: this.translate?.preventiveMaintenance.label.singular,
        deleteType: "Preventative Maintenance",
        id: e.rowData.id,
        message:
          this.translate?.general.messages.confirmDelete + " " + `${e.rowData.scheduleNumber}`,
      };
      this.push(
        this.deleteRecordService.getItems(item).subscribe(() => { this.refresh(); })
      );
    }
  }

  /******************************************** On Cell Clicked ******************************************/
  public view(e: any) {
    this.util.resetTabView();
    this.dynamicTableColumnsService.redirectURL(e);
  }

  /******************************************** Reset Filter ******************************************/
  public reset() {
    this.dateRange = undefined;
    this.filter = {
      statuses: null,
      types: "",
      fromDate: "",
      toDate: "",
      serviceZoneId: null,
    };
    this.onGridReady(this.gridParams);
  }

  /******************************************** On Date Change ******************************************/
  public onDateChange(event: any) {
    if (event && event.length) {
      this.selectedRange = event;
      this.filter.fromDate = moment(this.selectedRange[0]).format("YYYY-MM-DD");
      this.filter.toDate   = moment(this.selectedRange[1]).format("YYYY-MM-DD");
    } else {
      this.filter.fromDate = "";
      this.filter.toDate   = "";
    }
    if (this.selectedRange[0] && this.selectedRange[1]) { this.refresh(); }
  }

  /******************************************** Redirect To New Tab ******************************************/
  public redirectToNewTab(data: any) {
    let url = "";
    if (data.field === "scheduleNumber") {
      url = this.router.serializeUrl(
        this.router.createUrlTree(
          ["/dashboard/preventative-maintenance/view/" + data.id],
          { queryParams: { id: data.id } }
        )
      );
    }
    url = url.replace("%23", "#");
    window.open(url, "_blank");
  }

  /******************************************** Context Menu ******************************************/
  public getContextMenuItems = (params: any) => {
    const result = [];
    params.node.data.field = params.column.colId;
    if (params.column.colId == "scheduleNumber") {
      result.push({
        name: "Open link in new tab",
        action: () => this.redirectToNewTab(params.node.data),
      });
    }
    return result;
  };

  /******************************************** Filter Toggle ******************************************/
  public filterToggle() {
    this.isFilterToggleOn = !this.isFilterToggleOn;
    this.isFilterClosed.emit(this.isFilterToggleOn);

    if (this.filterAPILoaded === false) {
      this.push(
        this.serviceZoneService.getAllServiceZones().subscribe((res: any) => {
          this.serviceZones = res.sort((a: any, b: any) =>
            a?.order > b?.order ? 1 : a?.order < b?.order ? -1 : 0
          );
        })
      );

      if (this.addonFeatureDYNAMIC) {
        this.jobOrderService.getJobOrderTypes(true).subscribe((resp) => {
          this.allJobOrderTypes = resp
            .map((joT: any) => ({ id: joT.id, value: joT.name, label: joT.label, order: joT.order }))
            .sort((a: any, b: any) => (a?.order > b?.order ? 1 : a?.order < b?.order ? -1 : 0));
        });
      }

      this.filterAPILoaded = true;
    }
  }

  /******************************************** Return Label ******************************************/
  public returnLabel(what: string, value: string) {
    let label = "";
    if (what === "types")       { label = this.allTypes.find((type: any)     => type.value  === value)!.label; }
    if (what === "status")      { label = this.allStatus.find((s: any)       => s.value     === value)!.label; }
    if (what === "serviceZone") { label = this.serviceZones.find((zone: any) => zone.id     == value)!.name;   }
    return label;
  }

  push(obs: any) { super.push(obs); }

  test() {
    console.log("test", this.gridParams);
    console.log("test", this.gridApi);
  }

  /******************************************** Load Empty Page ******************************************/
  loadEmptyPage() {
    this.util.getIntroPageData().subscribe(
      (data: any) => {
        if (localStorage.getItem('packageCode') == 'Coffee_Pro') {
          const assetData = JSON.parse(JSON.stringify(data.preventiveMaintenanceIntroPage));
          this.preventiveMaintenanceIntroPageData = this.util.replaceWordInObject(
            assetData, 'asset', 'equipment',
            new Set(['icon', 'route']),
            { caseInsensitive: true, wholeWord: true, preserveCase: true, allowPluralS: true }
          );
        } else {
          this.preventiveMaintenanceIntroPageData = data.preventiveMaintenanceIntroPage;
        }
        this.spinner.hide();
      },
      (error: any) => {
        console.error("Error loading intro page data:", error);
        this.spinner.hide();
      }
    );
  }
}